export default __webpack_public_path__ + "static/media/btn_add.75063a3e.svg";